import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/** requireAdmin: доступ к панели преподавателя (администратор или преподаватель с ограничениями) */
const PrivateRoute = ({ children, requireAdmin = false }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="loading">
                <p>Загрузка...</p>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (requireAdmin && user.role !== 'admin' && user.role !== 'teacher') {
        return <Navigate to="/student" replace />;
    }

    return children;
};

export default PrivateRoute;
